import { COLORS, NEUTRAL_TEXT300,NEUTRAL_TEXT400 } from '../../config/designSystem/Colors';
import { Feather, MaterialIcons } from '@expo/vector-icons';
import { IPathModel } from '../../state/stores/Path/PathModel';
import { ISession } from '../../state/stores/Session/SessionModel';
import { Pressable, TouchableOpacity, TouchableWithoutFeedback, View, ViewStyle } from 'react-native';
import { SessionCardMainPart } from './SessionCardMainPart';
import { Subtitle2 } from '../../config/designSystem/typography';
import { branchingKey, sessionStackKey } from '../../constants/routeKeys';
import { concatPath } from '../../utils/links/concatPath';
import { isWeb } from '../../config/designSystem/Layout';
import { logAmplitude } from '../../utils/analytics/analytics';
import { router } from 'expo-router';
import { useAvailableDimensions } from '../../hooks/ui/useAvailableDimensions';
import { useStores } from '../../hooks/useStores';


interface SessionCardProps {
    item: ISession;
    index: number;
    started: boolean;
    complete: boolean;
    sessionIndex:number;
    path: IPathModel;
    onPressSummary: (idx: number) => void;
    isSummaryAvailable: boolean;
    onPressFollow: () => void;
  }

export const SessionCard = ({ item, started,complete, index, sessionIndex, path, onPressSummary,onPressFollow, isSummaryAvailable}: SessionCardProps) => {


  const rootStore = useStores();

  const { width } = useAvailableDimensions();

  const MAX_WIDTH = Math.max(200, Math.min(width, 1000));


  const labels = rootStore?.language.translate.MOBILE.PATH;

  const previousDone = index < sessionIndex ;
  const currentDone = index <= sessionIndex;
  const hidden = !currentDone;
  const currentOne = index === sessionIndex ;
  const lastOne = path.totalNumberSessions && index === path.totalNumberSessions - 1;
  const firstOne = index === 0;
  const iconColor = NEUTRAL_TEXT400;

  const MARGIN_BETWEEN_CARDS = 30;

  const onPressSession = () => {
    logAmplitude('Session Started', {
      pathId: path?.humanReadableId,
      sessionId: item?.humanReadableId,
      from: 'path',
      element_interaction: 'session_card'
    });
    router.navigate({
      pathname: concatPath([ sessionStackKey, branchingKey], 2) as string,
      params: {
        pathId: path._id,
        sessionId: item._id,
        fromPath: encodeURIComponent(true),
        fromReckoning: encodeURIComponent(false),
      }});
  };


  const onPress = () => {
    if(!started && !complete) {
      onPressFollow();
    }
    if (currentDone || firstOne) {
      onPressSession();
    }
  };

  const renderBar = () => {
    const CIRCLE_COLOR= COLORS.brand[500];
    const ICON_SIZE = 19;
    const iconPosition = isWeb? 50 : 10;
    const MARGIN_BOTTOM_BAR = 5;
    return (
      <View style={{marginLeft: 10}}>

        {(!firstOne && (previousDone || currentOne)) ? (
          <View
            style={{
              width: 3,
              marginBottom: MARGIN_BOTTOM_BAR,
              backgroundColor: COLORS.state.success.primary ,
              height: iconPosition-MARGIN_BOTTOM_BAR,
              alignSelf: 'center',
              position:'absolute',
              top: 0
            }}
          />
        ) : null}

        {previousDone && (
          <View
            style={{
              backgroundColor: COLORS.state.success.primary,
              borderRadius: 18,
              height: ICON_SIZE,
              width: ICON_SIZE,
              alignItems:'center',
              justifyContent:'center',
              marginTop:iconPosition
            }}
          >
            <Feather name="check" color="#fff" size={12} />
          </View>
        )}
        {hidden && (
          <View
            style={{
              backgroundColor: '#fff',
              borderRadius: 18,
              marginTop: iconPosition,
              height: ICON_SIZE,
              width: ICON_SIZE,
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <MaterialIcons
              name="lock"
              color={NEUTRAL_TEXT300}
              size={18}
              style={{ textAlign: 'center', justifyContent: 'center' }}
            />
          </View>
        )}
        {currentOne && (
          <View
            style={{
              borderWidth: 3,
              borderColor: CIRCLE_COLOR,
              height: ICON_SIZE,
              width: ICON_SIZE,
              borderRadius: 20,
              alignItems: 'center',
              justifyContent: 'center',
              marginTop: iconPosition
            }}
          >
            <View style={{ height: 8, width: 8, backgroundColor: CIRCLE_COLOR, borderRadius: 12 }} />
          </View>
        )}

        {(!lastOne) ? (
          <View
            style={{
              width: 3,
              marginTop: 5,
              backgroundColor: previousDone ? COLORS.state.success.primary : '#F1F1F1',
              flex: 1,
              alignSelf: 'center',
            }}
          />
        ) : null}
      </View>
    );
  };



  const renderSummaryButton = () => {
    return (
      <TouchableWithoutFeedback>
        <TouchableOpacity onPress={() => onPressSummary(index)}>
          <View
            style={[
              {
                paddingHorizontal: 10,
                paddingVertical:12,
                justifyContent: 'center',
                alignItems: 'center',
              },
            ]}
          >
            <Subtitle2 color={COLORS.state.success.primary}>
              {labels?.SUMMARY}
            </Subtitle2>
          </View>
        </TouchableOpacity>
      </TouchableWithoutFeedback>
    );
  };




  const previousDoneStyle : ViewStyle = {
    borderColor: COLORS.state.success.primary
  };

  const currentOneStyle : ViewStyle = {
    borderColor: COLORS.brand[500],
    backgroundColor:'#F0EEFC',

  };

  const hiddenStyle : ViewStyle = {
    opacity: 0.5,
    borderColor:'#F1F1F1'
  };

  return (
    <View style={{ width: MAX_WIDTH }}>
      <Pressable
        style={{flexDirection: 'row', marginHorizontal: 15, marginBottom: 0 }}
        onPress={onPress}

      >
        {renderBar()}

        <View
          style={[
            {
              flex: 1,
              paddingVertical: 20,
              paddingHorizontal:16,
              marginHorizontal: 15,
              marginBottom: MARGIN_BETWEEN_CARDS,
              borderWidth: 1,
              borderRadius:15
            },
            previousDone && {...previousDoneStyle},
            currentOne && {...currentOneStyle},
            hidden && {...hiddenStyle}
          ]}
        >

          <SessionCardMainPart item={item} index={index}
            showSummary={previousDone && isSummaryAvailable}
            renderSummary={renderSummaryButton}
            iconColor={iconColor}
            numberColor={(previousDone || hidden)?NEUTRAL_TEXT400:COLORS.brand[500]}
          />

        </View>
      </Pressable>
    </View>

  );
};
